<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/router/views_mobagile/components/loader.vue";
import api from "@/axios";
import moment from "moment/moment";
import { useMagicKeys, whenever } from '@vueuse/core'
import Swal from "sweetalert2";
import Stat from "@/components/widgets/stat.vue";
import {SimpleBar} from "simplebar-vue3";
import { DxSwitch } from 'devextreme-vue/switch'
import {getBaseUrl} from "@/helpers/baseUrl";
import PageActionBar from "@/components/page-action-bar.vue";

export default {
  page: {
    title: "Editar OS Saída",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {SimpleBar, Stat, Loader, Layout, PageHeader, DxSwitch, PageActionBar },
  data() {
    return {
      title: "Editar OS de Romaneio",
      items: [
        {
          text: "Ordens de Serviço",
          href: "/wmsossaida/list",
        },
        {
          text: "Editar OS de Romaneio",
          active: true
        }
      ],

      idData: 0,
      updating: true,
      updatingListas: false,
      wmsOsRomaneioData: {},

      WmsOssDataAseparar:[],
      WmsOssDataSeparados:[],
      ocultaConferidos: true,




      wmsOsListData: null,

      wmsOsData: {
        id: 0,
        status: "EL",
        formapgto: '10',
        condpgto: '10',
        fornec: '23',
        tipo: '06',
        dtemissao: new Date
      },
      clienteData: {},
      movData: {},
      wmsOsItemData: {},
      wmsOsItensData: {},
      wmsOsItensDataConferido: [],
      wmsOsItensDataNaoConferido: [],
      wmsOsItensExibir: [],

      wmsOsItensSepData: {},
      wmsOsVolumesData: {},
      wmsOsVolumeData: {},

      submitted: false,
      errosValid: null,
      tipoConferencia: 'A',
      tipoVolume: 'A',
      showModalVolume: false,
      loadingWmsVolume: false,
      somaQtdVolumes: 0,
      somaPesoVolumes: 0,
      showAssocRoma: false,
      dtListPesqRoma: null,

      totalPedidos: "0",
      totalItens: "0",

      totalPedidosFalta: "0",
      totalItensFalta: "0",

      totalPedidosConcl: "0",
      totalItensConcl: "0",



    }
  },
  created() {



  },
  mounted() {
    const keys = useMagicKeys()

    whenever(keys.alt_e, () => {
      this.$refs.codbarranovo.focus()
    })

    whenever(keys.alt_i, () => {
      this.$refs.codigonovo.focus()
    })

    whenever(keys.alt_z, () => {
      this.finalizar()
    })


    console.log('mounted_wmsOs_editar_transp_0')
    let rota = this.$route.path

    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)

    if (this.idData > 0){
      this.carregarDados()

    }else{
      this.title = `Criando Nova OS`
      this.updating = false

    }




  },
  methods: {

    mudouExib(){
      console.log('mudouExib')
      console.log(this.ocultaConferidos)

      if (this.ocultaConferidos) {
        this.wmsOsItensExibir = this.wmsOsItensDataNaoConferido
      } else {
        this.wmsOsItensExibir = this.wmsOsItensData
      }



    },

    separarOss(listWmsOsss) {
      console.log('separarOss')
      this.WmsOssDataAseparar = []

      let totalPed = 0
      let totalPedSep = 0
      let totalPedPend = 0


      listWmsOsss.forEach((value) => {
        // console.log('value')
        // console.log(value)
        totalPed++
        if (value.status === 'SE'){
          this.WmsOssDataSeparados.push(value)
          totalPedSep++
        } else {
          this.WmsOssDataAseparar.push(value)
          totalPedPend++
        }
      })

      this.totalPedidos = totalPed.toString()
      this.totalPedidosConcl = totalPedSep.toString()
      this.totalPedidosFalta = totalPedPend.toString()

    },




    imprimirEtiquetas() {
      console.log('imprimirEtiqueta')
      this.updating = true

      api.get(`${getBaseUrl()}api/wmsosvoletiqstra`, {
        responseType: 'blob',
        params: { iddata: this.idData}
      }).then((res) => {

        console.log('then imprimirEtiquetas')
        console.log(res.data)

        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'etiqueta_.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.updating = false
      })
    },


    imprimirEtiquetasZpl() {
      console.log('imprimirEtiqueta')
      this.updating = true

      api.get(`${getBaseUrl()}api/wmsosvoletiqstrazpl`, {
        responseType: 'blob',
        params: { iddata: this.idData}
      }).then((res) => {

        console.log('then imprimirEtiquetas')
        console.log(res.data)

        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'etiqueta_.zpl');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.updating = false
      })
    },



    informouQtdVolume(){
      console.log('informouQtdVolume')
      this.$refs.pesovolume.focus()

    },

    informouPeso() {
      console.log('informouPeso')
      this.confirmarVolume()

    },

    imprimirEtiqueta(idVol) {
      console.log('imprimirEtiqueta')
      this.loadingWmsVolume = true

      api.get(`${getBaseUrl()}api/wmsosvoletiqtra`, {
        responseType: 'blob',
        params: { iddata: idVol}
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'etiqueta_.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loadingWmsVolume = false
      })

    },


    finalizar() {
      console.log('finalizar')


      if (this.wmsOsData.qtddisp === 0.00) {

        Swal.fire({
          position: "center",
          icon: "question",
          title: "Finalizar Conferência",
          text: "Esta operação é irreversível, tem certeza que deseja continuar?",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,
        }).then(result => {
          if (result.value) {




            // console.log(result.value)
            // console.log('vai')
            // this.wmsOsItemData['idwmsos'] = this.idData
            // this.updatingListas = true
            //
            api.post(`${getBaseUrl()}api/wmsosfinalsep`, {
              'iddata': this.idData
            }).then((res) => {
              console.log('then axios separar2_0')
              console.log(res.data)
              this.wmsOsData = res.data[0]

              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Comando Finalizar executado com sucesso!",
                showConfirmButton: false,
                timer: 1500
              })



            })


          }
        })

      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Quantidade pendente de separação deve ser igual a zero, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })
      }



    },




    clicouCodBarra(rowData){
      console.log('clicouCodBarra')
      console.log(rowData)
      console.log(rowData.qtd)
      if (rowData.qtd > 1) {
        // /wmsos/saidaeditarnova/875
        this.$router.push(`/wmsos/saidaeditarnova/${rowData.wmsos_id}`);
      } else {
        this.wmsOsItemData = rowData
        this.$refs.codbarranovo.focus()
      }
    },

    clicouCodigo(rowData){
      console.log('clicouCodigo')
      console.log(rowData)
      this.wmsOsItemData = rowData
      this.$refs.codigonovo.focus()
    },


    informouCodigoBarra() {
      console.log('informouCodigoBarra')
      console.log(this.wmsOsItemData)
      let wmsOsItemDataPost = null
      if (this.wmsOsItemData.codbarra) {
        this.wmsOsItensData.forEach((value) => {
          if (value.codbarra === this.wmsOsItemData.codbarra && value.qtddisp > 0) {
            console.log('value')
            console.log(value.qtddisp)
            wmsOsItemDataPost = value
          }
        })
      }
      console.log('wmsOsItemDataPost.id')
      console.log(wmsOsItemDataPost)
      if (wmsOsItemDataPost && wmsOsItemDataPost.id) {
        this.updating = true
        api.post(`${getBaseUrl()}api/wmsosconfsepromaitem`, {
          'iddata': wmsOsItemDataPost.id
        }).then((res) => {
          console.log('then axios confsepitem')
          console.log(res.data)
          this.wmsOsItemData = {}
          this.carregarDados()
        })
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Produto não disponível.",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },


    // informouCodigo() {
    //   console.log('informouCodigo')
    //   console.log(this.wmsOsItemData)
    //   if (this.wmsOsItemData.codbarra) {
    //     this.wmsOsItensData.forEach((value) => {
    //       console.log('value')
    //       console.log(value)
    //       if (value.produto === this.wmsOsItemData.codigo && value.qtddisp > 0) {
    //         this.wmsOsItemData = value
    //       }
    //     })
    //   }
    //   console.log('this.wmsOsItemData.id')
    //   console.log(this.wmsOsItemData.id)
    //   if (this.wmsOsItemData.id) {
    //     api.post(`${getBaseUrl()}api/wmsosconfsepromaitem`, {
    //       'iddata': this.wmsOsItemData.id
    //     }).then((res) => {
    //       console.log('then axios confsepitem')
    //       console.log(res.data)
    //       this.wmsOsItemData = {}
    //       this.carregarDados()
    //     })
    //   } else {
    //     Swal.fire({
    //       position: "top-end",
    //       icon: "warning",
    //       title: "Produto não disponível.",
    //       showConfirmButton: false,
    //       timer: 1500
    //     })
    //   }
    // },

    informouCodigo() {
      console.log('informouCodigo')
      console.log(this.wmsOsItemData)
      let wmsOsItemDataPost = null
      if (this.wmsOsItemData.codigo) {
        this.wmsOsItensData.forEach((value) => {
          if (value.codigo === this.wmsOsItemData.produto && value.qtddisp > 0) {
            console.log('value')
            console.log(value.qtddisp)
            wmsOsItemDataPost = value
          }
        })
      }
      console.log('wmsOsItemDataPost.id')
      console.log(wmsOsItemDataPost)
      if (wmsOsItemDataPost && wmsOsItemDataPost.id) {
        this.updating = true
        api.post(`${getBaseUrl()}api/wmsosconfsepromaitem`, {
          'iddata': wmsOsItemDataPost.id
        }).then((res) => {
          console.log('then axios confsepitem')
          console.log(res.data)
          this.wmsOsItemData = {}
          this.carregarDados()
        })
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Produto não disponível.",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },


    carregarDados(){
      this.updating = true
      api.get(`${getBaseUrl()}api/wmsossaidaroma`, {
        params: {
          iddata: this.idData
        }
      }).then((res) => {
        console.log('then axios wmsosEditar')
        console.log(res.data)
        this.wmsOsRomaneioData = res.data[0]
        this.separarOss(res.data[1])

        this.wmsOsItensData = res.data[2]
        let totalIt = 0
        let totalItConcl = 0
        let totalItFalta = 0
        this.wmsOsItensDataNaoConferido = []
        this.wmsOsItensDataConferido = []
        this.wmsOsItensData.forEach((wmsItem) => {
          // console.log('wmsItem')
          // console.log(wmsItem)
          totalIt++
          if (wmsItem.qtddisp > 0) {
            totalItFalta++
            this.wmsOsItensDataNaoConferido.push(wmsItem)
          } else {

            this.wmsOsItensDataConferido.push(wmsItem)
            totalItConcl++
          }
        })

        if (this.ocultaConferidos) {
          this.wmsOsItensExibir = this.wmsOsItensDataNaoConferido
        } else {
          this.wmsOsItensExibir = this.wmsOsItensData
        }

        this.totalItens = totalIt.toString()
        this.totalItensConcl = totalItConcl.toString()
        this.totalItensFalta = totalItFalta.toString()

        this.title = `Editar OS de Romaneio (${this.wmsOsRomaneioData.id})`
        this.updating = false
      })
    },


    confirmarVolume() {
      console.log('confirmarVolume')
      if (this.wmsOsVolumeData.qtd > 0 && this.wmsOsVolumeData.peso > 0){
        this.loadingWmsVolume = true
        // this.loadingWmsEnder = true
        // console.log(this.wmsOsItemSepData.produto)
        api.post(`${getBaseUrl()}api/wmsosconfvol`, {
          'idwmsos': this.idData,
          'qtd': this.wmsOsVolumeData.qtd,
          'peso': this.wmsOsVolumeData.peso,
        }).then((res) => {
          console.log('then axios conf_vol')
          console.log(res.data)
          this.wmsOsVolumesData = res.data[0]
          let totalVols = 0
          let pesoVols = 0
          this.wmsOsVolumesData.forEach((value) => {
            totalVols += value.qtd
            pesoVols += value.peso
          });
          this.somaQtdVolumes = totalVols
          this.somaPesoVolumes = pesoVols
          this.loadingWmsVolume = false
          this.wmsOsVolumeData = {}
          this.$refs.qtdvolume.focus()
        })
      }
    },


    nomeStatusWms(stsIn){
      let result = 'Não Conferido'
      switch (stsIn) {
        case 'SE':
          result = 'Conferido'
          break
      }
      return result
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },

};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" :status="wmsOsRomaneioData.status"/>

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>






    <div class="row" v-if="!updating">
      <div class="col-xl-12">
        <div class="row">
          <div class="col-6 col-md-2">
            <Stat icon="bx bx-cart" title="Total Pedidos" :value="totalPedidos" />
          </div>
          <div class="col-6 col-md-2">
            <Stat icon="bx bxs-dashboard" title="Total Itens" :value="totalItens" />
          </div>

          <div class="col-6 col-md-2">
            <Stat icon="bx bx-minus" title="Itens Faltantes" :value="totalItensFalta" />
          </div>
          <div class="col-6 col-md-2">
            <Stat icon="bx bx-minus-circle" title="Pedidos Faltantes" :value="totalPedidosFalta" />
          </div>

          <div class="col-6 col-md-2">
            <Stat icon="bx bx-check" title="Itens Concluídos" :value="totalItensConcl" />
          </div>
          <div class="col-6 col-md-2">
            <Stat icon="bx bx-check-double" title="Pedidos Concluídos" :value="totalPedidosConcl" />
          </div>
        </div>
      </div>
    </div>



    <div class="row" v-if="!updating">

      <SimpleBar
          style="max-height: 600px"
          id="containerElement"
          ref="current">



        <div class="col-lg-12" v-if="!updating">
          <div class="card">
            <div class="card-body">
              <PageActionBar
                :primary-actions="[
                  {
                    label: 'Finalizar (alt + Z)',
                    icon: 'mdi mdi-check',
                    variant: 'success',
                    onClick: finalizar,
                    visible: wmsOsData && wmsOsData.status === 'AB'
                  }
                ]"
                :secondary-actions="[
                  {
                    label: 'Imprimir Etiquetas (alt + E)',
                    icon: 'bx bx-printer',
                    variant: 'outline-primary',
                    onClick: imprimirEtiquetas,
                    disabled: !wmsOsVolumesData || wmsOsVolumesData.length === 0
                  },
                  {
                    label: 'Etiquetas ZPL (TESTES)',
                    icon: 'bx bx-printer',
                    variant: 'outline-primary',
                    onClick: imprimirEtiquetasZpl,
                    disabled: !wmsOsVolumesData || wmsOsVolumesData.length === 0
                  },
                  {
                    label: 'Volumes (alt + V)',
                    icon: 'bx bx-box',
                    variant: 'outline-primary',
                    onClick: () => showModalVolume = true
                  }
                ]"
              >
                <template #extra>
                  <DxSwitch
                      v-model:value="ocultaConferidos"
                      switchedOnText="Ocultar Conferidos"
                      switchedOffText="Exibir Conferidos"
                      width="100px"
                      @value-changed="mudouExib"
                      :disabled="false"/>
                </template>
              </PageActionBar>
            </div>
          </div>
        </div>

      <div class="col-xl-12">
        <b-card-text>
          <div class="card">
            <div class="card-body">
              <!--              <h4 class="card-title">Informações Principais</h4>-->
              <!--                <p class="card-title-desc">Favor preencher corretamente os campos abaixo</p>-->
              <form class="needs-validation">
                <div class="row">

                  <div class="col-sm-6">
                    <div class="mb-3">
                      <label for="codbarranovo">Código EAN</label>
                      <input
                          id="codbarranovo"
                          v-model="wmsOsItemData.codbarra"
                          type="text"
                          ref="codbarranovo"
                          class="form-control"
                          placeholder="Código EAN (alt + E)"
                          @keypress.enter="informouCodigoBarra"/>

                    </div>
                  </div>


                  <div class="col-sm-6">
                    <div class="mb-3">
                      <label for="codigonovo">Código Interno</label>
                      <input
                          id="codigonovo"
                          v-model="wmsOsItemData.produto"
                          type="text"
                          ref="codigonovo"
                          class="form-control"
                          placeholder="Código Interno (alt + I)"
                          @keypress.enter="informouCodigo"/>
                    </div>
                  </div>



                </div>

                <div class="row">

                  <div class="row">
                  </div>


                </div>

              </form>

              <Loader v-if="updatingListas" style="min-height: 200px;">
              </Loader>

              <div class="row mt-5 mb-2" v-if="!updatingListas">
                <h4 class="card-title">Produto(s) para separação ({{ wmsOsItensExibir !== null ? wmsOsItensExibir.length : 0 }})</h4>
                <div class="table-responsive">
                  <table class="table align-middle mb-0 table-nowrap">
                    <thead class="table-light">
                    <tr>
                      <th>ID</th>
                      <th>Núm.NF.</th>
                      <th style="min-width: 10%;">Remetente</th>
                      <th style="min-width: 10%;">Destinatário</th>
                      <th style="min-width: 30%;">Produto</th>
                      <th>EAN</th>
                      <th>Código</th>
                      <th class="text-end">Qtd.Itens</th>
                      <th class="text-end">Lidos</th>
                      <th class="text-end">Falta</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="data in wmsOsItensExibir" :key="data.id">
                      <td>
                        <h5 class="font-size-14 text-truncate">
                          <a href="javascript: void(0);"
                             @click="clicouCodBarra(data)"
                             class="text-body fw-bold text-wrap" >
                            {{ data.id }}
                          </a>
                        </h5>
                      </td>
                      <td>{{ data.numnf }}</td>
                      <td class="text-wrap">{{ data.nomeremet }}</td>
                      <td class="text-wrap">{{ data.nomedest }}</td>
                      <td class="text-wrap">{{ data.descprod }}</td>

                      <td>
                        <h5 class="font-size-14 text-truncate">
                          <a href="javascript: void(0);"
                             @click="clicouCodBarra(data)"
                             class="text-body fw-bold text-wrap" >
                            {{ data.codbarra }}
                          </a>
                        </h5>
                      </td>

                      <td>
                        <h5 class="font-size-14 text-truncate">
                          <a href="javascript: void(0);"
                             @click="clicouCodigo(data)"
                             class="text-body fw-bold text-wrap" >
                            {{ data.produto }}
                          </a>
                        </h5>
                      </td>


                      <td class="text-end">{{ formatInteger(data.qtd) }}</td>
                      <td class="text-end">{{ formatInteger(data.qtdlida) }}</td>
                      <td class="text-end">{{ formatInteger(data.qtd - data.qtdlida) }}</td>

                    </tr>
                    </tbody>
                  </table>
                </div>

              </div>

            </div>
          </div>

        </b-card-text>


      </div>

      </SimpleBar>

    </div>


    <b-modal  size="lg"
              @shown="$refs.qtdvolume.focus()"
              title="Identificar Volume(s)" v-model="showModalVolume" centered hide-footer>

      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="quantidade">Quantidade</label>
            <input
                id="qtdvolume"
                ref="qtdvolume"
                v-model="wmsOsVolumeData.qtd"
                type="number"
                class="form-control text-end"
                @keypress.enter="informouQtdVolume"
                placeholder="Enter para confirmar..."/>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="pesovolume">Peso</label>
            <input
                id="pesovolume"
                ref="pesovolume"
                v-model="wmsOsVolumeData.peso"
                type="number"
                class="form-control text-end"
                @keypress.enter="informouPeso"
                placeholder="Enter para confirmar..."/>
          </div>
        </div>

      </div>


      <div class="row" v-if="loadingWmsVolume">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>



      <div class="table-responsive" v-if="wmsOsVolumesData">
        <table class="table table-centered table-nowrap">
          <thead>
          <tr>

            <th scope="col" class="">ID</th>
            <th scope="col" class="">Etiqueta</th>

            <th scope="col" class="text-end">Peso</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="data in wmsOsVolumesData" :key="data.id">

            <td>
              <div>
                <h5 class="text-truncate font-size-14">
                  {{ data.id }}
                </h5>
              </div>
            </td>

            <td class="text-info">
              <a href="javascript:void(0);" @click="imprimirEtiqueta(data.id)">
                <i class="mdi mdi-printer"></i>
                {{ data.etiqueta }}
              </a>
            </td>


            <td class="text-end">{{ formatDecimal(data.peso) }}</td>
          </tr>

          <tr>
            <td colspan="2">
              <h6 class="m-0 text-end">Quantidade Total Volumes:</h6>
            </td>
            <td class="text-end"> {{ formatDecimal(somaQtdVolumes) }}</td>
          </tr>

          <tr>
            <td colspan="2">
              <h6 class="m-0 font-size-14  text-end">Peso Total Volumes:</h6>
            </td>
            <td class="font-size-14 text-end"> {{ formatDecimal(somaPesoVolumes) }}</td>
          </tr>

          </tbody>
        </table>
      </div>




      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalVolume = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>

        <!--          <b-button type="submit" variant="success" class="ms-1"-->
        <!--                    :disabled="this.wmsOsItemSepData.disp <= 0 || wmsOsItemSepData.qtd === 0 || wmsOsItemSepData.qtd > this.wmsOsItemSepData.disp || !wmsOsItemSepData.palete"-->
        <!--                    @click="confirmarSeparacao">-->
        <!--            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>-->
        <!--            Confirmar-->
        <!--          </b-button>-->

        <!--        <b-button type="submit" variant="success" class="ms-1"-->
        <!--                  v-if="wmsOsVolumesData.length > 0"-->
        <!--                  @click="imprimirEtiquetas">-->
        <!--          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>-->
        <!--          Imprimir Etiquetas-->
        <!--        </b-button>-->



        <b-button type="submit" variant="success" class="ms-1"
                  :disabled="!this.wmsOsVolumeData.qtd || this.wmsOsVolumeData.qtd <= 0 || !this.wmsOsVolumeData.peso || this.wmsOsVolumeData.peso <= 0 "
                  @click="confirmarVolume">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar Novo Volume
        </b-button>

      </div>
    </b-modal>




  </Layout>
</template>
